import { SearchOutlined } from "@ant-design/icons";
import { Button, Flex, Input } from "@p0security/ui";
import { PropsWithChildren, useCallback } from "react";
import { stopPropagation } from "utils/javascript";

/** Wraps a table whose rows are clickable: rows take a pointer cursor and lose
 * their separating rules, and only the first column stays emphasized. */
export const StyledTableContainer: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="[&_.ant-table-tbody>tr]:cursor-pointer! [&_.ant-table-tbody>tr>td]:border-b-0! [&_.ant-table-tbody>tr>td:not(:first-child)_div]:font-normal! [&_.ant-table-tbody>tr>td:not(:first-child)_span]:font-normal! [&_.ant-table-tbody>tr>td:not(:first-child)_p]:font-normal!">
    {children}
  </div>
);
/** Free-text column filter, fully controlled by `value`/`onChange` rather than
 * antd's internal filterDropdown render-prop state, so it can be seeded from
 * (and kept in sync with) a URL-backed filter value. */
export const FilterDropdown = ({
  value,
  onChange,
  confirm,
  placeholder,
}: {
  value: string | null;
  onChange: (value: string | null) => void;
  confirm: () => void;
  placeholder?: string;
}) => {
  const switchFilter = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      onChange(e.target.value || null),
    [onChange]
  );
  const resetSearch = useCallback(() => {
    onChange(null);
    confirm();
  }, [confirm, onChange]);

  return (
    <div className="flex flex-col gap-2 p-2" onClick={stopPropagation}>
      <Input
        placeholder={placeholder}
        value={value ?? ""}
        onChange={switchFilter}
        onPressEnter={confirm}
      />
      <Flex justify="space-between">
        <Button
          onClick={resetSearch}
          type="link"
          size="small"
          disabled={!value}
        >
          Reset
        </Button>
        <Button type="primary" onClick={confirm} size="small">
          Search
        </Button>
      </Flex>
    </div>
  );
};

export const FilterIcon = () => <SearchOutlined />;

export const CellAction: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div onClick={stopPropagation}>{children}</div>;
